<template>
    <section class="wrap">
        <div class="card-container">
            <Card
                v-for="(card, index) in cards.data" :key="card.key_index"
                :current="index === cards.index"
                :card="card"
                :fullName="card.member.name"
                :picture="card.member.profile"
                :approved="card.approved"
                :ovrList="card.ovr_list"
                @draggedThreshold="setApproval">
            </Card>
            <h1>지금 용병구함에서<br />사커비 용병과 함께 뛰어봐요!<br />용병카드를 넘겨보세요.</h1>
        </div>
    </section>
</template>

<script>
    import client from "../client/client";
    import { ref, reactive, onMounted } from 'vue';
    import Card from './Card.vue';
    

    export default {
    components: {
        Card
    },
    data() {
        return {
            index: 0,
        }
    },
    setup() {
        const isLoading = ref(true);
        const index = ref(0);
        const cards = reactive({
            data: null,
            index: 0,
            max: 3
        });

        const getData = async() => {
            isLoading.value = true;
            const list = await client.get(`/api/join/yong/list?index=${index.value}`);
            
            if(list && list.r) {
                cards.data = [...list.list];
                cards.index = 0;
                isLoading.value = false;
            } else {
                isLoading.value = false;
            }
        };



        const setApproval = (approval) => {
            cards.data[cards.index].approved = approval;
            cards.index++;
            index.value++;

            if (cards.index >= cards.data.length) {
                getData();
            }
        };

        onMounted(getData);

        return {
        isLoading,
        cards,
        getData,
        setApproval
        };
    }
    };
</script>

<style scoped lang="scss">
    @import "../assets/css/swipe.scss";
    .wrap {
        width: 100%;
        height:100%;
        overflow: hidden;
        touch-action: none;
    }

    .loading_ic{
        position: relative;
        width: 12px;
        height: 12px;

        top: 46%;
        top: -webkit-calc(50% - 6px);
        top: calc(50% - 6px);
        left: 46%;
        left: -webkit-calc(50% - 6px);
        left: calc(50% - 6px);

        border-radius: 12px;
        background-color: #000000;
        -webkit-transform-origin:  50% 50%;
        transform-origin:  50% 50% ;
        -webkit-animation: loading 1s ease-in-out infinite;
        animation: loading 1s ease-in-out infinite;
    }

    .loading_ic:before{
        content: "";
        position: absolute;
        background-color: rgba(0,0,0, 1);
        top: 0px;
        left: -25px;
        height: 12px;
        width: 12px;
        border-radius: 12px;
    }

    .loading_ic:after{
        content: "";
        position: absolute;
        background-color: rgba(0,0,0 ,1);
        top: 0px;
        left: 25px;
        height: 12px;
        width: 12px;
        border-radius: 12px;
    }


    @-webkit-keyframes loading{
        0%{-webkit-transform:rotate(0deg);}
        50%{-webkit-transform:rotate(180deg);}
        100%{-webkit-transform:rotate(180deg);}
    }

    @keyframes loading{
        0%{transform:rotate(0deg);}
        50%{transform:rotate(180deg);}
        100%{transform:rotate(180deg);}
    }
</style>